import { render, staticRenderFns } from "./courseDocuments.vue?vue&type=template&id=7053e1e0&scoped=true&"
import script from "./courseDocuments.vue?vue&type=script&lang=js&"
export * from "./courseDocuments.vue?vue&type=script&lang=js&"
import style0 from "./courseDocuments.vue?vue&type=style&index=0&id=7053e1e0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7053e1e0",
  null
  
)

export default component.exports